import { ArticleHeading1, ArticleHeading2, TDeviceType } from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import styles from './AnswersOnQuestions.css';
import { TYPOGRAPHY, FAQ_DATA } from './constants';
import { Section } from '../Section';
import { SectionTitle } from '../SectionTitle';

interface IAnswersOnQuestionsProps {
  deviceType: TDeviceType;
  activeFaqIndex: number | null;
  onFaqItemClick: (index: number) => void;
}

export const AnswersOnQuestions: React.FC<IAnswersOnQuestionsProps> = ({
  deviceType,
  activeFaqIndex,
  onFaqItemClick,
}) => {
  const AdaptiveHeading = deviceType === 'desktop' ? ArticleHeading1 : ArticleHeading2;

  return (
    <Section deviceType={deviceType}>
      <div
        className={cn(styles['container'], styles[`container-${deviceType}`])}
        id="answersOnQuestions"
        data-testid="AnswersOnQuestionsContainer"
      >
        <SectionTitle deviceType={deviceType}>{TYPOGRAPHY.SECTION_TITLE}</SectionTitle>
        <ul className={styles['list']}>
          {FAQ_DATA.map(({ question, answer }, index) => {
            const isOpened = activeFaqIndex === index;

            return (
              <li className={styles['list-item']} key={index}>
                <button
                  className={styles['list-item-container']}
                  onClick={() => onFaqItemClick(index)}
                  data-testid="FaqListItem"
                >
                  <AdaptiveHeading whiteSpace="pre-line" color="white_100">
                    {question}
                  </AdaptiveHeading>
                  <div className={cn(styles['icon'], { [styles['active']]: isOpened })} />
                </button>
                <div className={cn(styles['content'], { [styles['active']]: isOpened })} data-testid="FaqListAnswer">
                  {answer}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </Section>
  );
};
